<template>
  <div class="container">
    <cdn-svg path="graphics/gatheround-by-donut" />

    <div class="m-tx6">
      <div class="f f-as">
        <div class="f-v m-rx6">
          <div class="t-xxxl bold">Present better.</div>
          <div class="t-xxxl bold">Facilitate smarter.</div>

          <div class="m-tx6 t-xl">Gatheround helps you run onboarding, training, and coaching sessions that foster real learning and keep teams from tuning out. <a class="link t-xl bold" target="_blank" href="https://www.donut.com/platform/gatheround/">Learn more</a></div>

          <div v-if="accessNoticeConfig.show" class="m-tx4">
            <p class="t bold">{{ accessNoticeConfig.title }}</p>
            <p v-if="accessNoticeConfig.description" class="t t-sm">{{ accessNoticeConfig.description }}</p>
          </div>

          <div class="m-tx1">
            <donut-button
              :disabled="isCtaDisabled"
              :show-upgrade-badge="showUpgradeBadge"
              :class="ctaButtonClass"
              @click="handleCtaClick"
            >
              {{ ctaButtonText }}
            </donut-button>
          </div>
        </div>

        <cdn-img class="w-x60" style="max-width: 50%;" path="graphics/gatheround-screens" />
      </div>

      <div class="m-tx8 f-v f-ac">
        <p class="t bold">Real teams, real results</p>
        <p class="t m-tx1">See how teams are driving engagement and collaboration in every session.</p>
        <div class="f f-jc f-sb w-x80 m-tx6">
          <a href="https://gatheround.com/customer-stories/calendly" target="_blank"><cdn-svg path="graphics/logo_calendly" /></a>
          <a href="https://gatheround.com/customer-stories/lyft" target="_blank"><cdn-svg path="graphics/logo_lyft" /></a>
          <a href="https://gatheround.com/customer-stories/valimail" target="_blank"><cdn-svg path="graphics/logo_valimail" /></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    subscriptionStatus: {
      type: String,
      required: true,
      validator: (value) => ['premium', 'standard', 'free'].includes(value),
    },
    handoffRequestUrl: {
      type: String,
      required: true,
    },
    isTrialAllowed: {
      type: Boolean,
      default: false,
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
  },

  computed: {

    isPremium() {
      return this.subscriptionStatus === 'premium';
    },

    isCtaDisabled() {
      return this.subscriptionStatus === 'standard' && !this.isAdmin;
    },

    showUpgradeBadge() {
      return !this.isPremium;
    },

    ctaButtonClass() {
      return this.isCtaDisabled ? 'inv' : '';
    },

    ctaButtonText() {
      return 'Try Gatheround';
    },

    showUpgradeNotice() {
      return !this.isCtaDisabled && !this.isPremium;
    },

    // Access notice configuration based on subscription status and admin status
    accessNoticeConfig() {
      if (this.subscriptionStatus === 'premium') {
        return {
          show: true,
          type: 'success',
          title: 'Gatheround is included in your plan',
          description: '',
        };
      }

      if (this.showUpgradeNotice) {
        return {
          show: true,
          type: 'upgrade',
          title: 'Gatheround is included in Donut Premium',
          description: '',
        };
      }

      if (this.isCtaDisabled) {
        return {
          show: true,
          type: 'restriction',
          title: 'Gatheround requires a Premium subscription',
          description: 'Contact your workspace admin to upgrade to Premium',
        };
      }

      return {
        show: false,
        type: '',
        title: '',
        description: '',
      };
    },
  },

  methods: {
    handleCtaClick() {
      window.mixpanel.track('Try Gatheround Button Clicked', {
        subscriptionStatus: this.subscriptionStatus,
        isTrialAllowed: this.isTrialAllowed,
        isAdmin: this.isAdmin,
      });

      if (this.isPremium) {
        // Submit form to handoff URL
        this.submitHandoffForm();
      } else if (!this.isCtaDisabled) {
        // Open upgrade modal
        this.openUpgradeModal();
      }
    },

    submitHandoffForm() {
      // Create and submit a form to the handoff URL
      window.mixpanel.track('Gatheround Handoff Form Submitted', {
        subscriptionStatus: this.subscriptionStatus,
        isTrialAllowed: this.isTrialAllowed,
        isAdmin: this.isAdmin,
      });
      const form = document.createElement('form');
      form.method = 'GET';
      form.action = this.handoffRequestUrl;
      document.body.appendChild(form);
      form.submit();
    },

    openUpgradeModal() {
      this.$store.dispatch('openChannelProgramsPlanUpgradeModal', {
        trialAllowed: this.isTrialAllowed,
        data: {
          allowPlanSelection: false,
          defaultPremiumPlan: true,
          featureTitleText: 'access Gatheround',
          source: 'gatheround_landing_page',
          redirectLocation: this.handoffRequestUrl, // Redirect to handoff after successful upgrade
        },
      });
    },
  },
};
</script>
